import axios from "axios";
import { sessionizeUrl } from "../main";
import atlasAPI from '../services/atlasAPI'


export const showeffect = (context, payload) => {
    context.commit("setEffect", payload);
}
export const counterUpdate = (context, payload) => {
    context.commit("setCount", payload.count);
}

export const speakerUpdate = (context, payload) => {
    context.commit("speakerUpdate", payload);
}

export const maproomUpdate = (context, payload) => {
    context.commit("maproomUpdate", payload);
}

export const mongoDB = ({ state, dispatch, commit }) => {


    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://eu-central-1.aws.data.mongodb-api.com/app/application-0-rvxwc/endpoint/test',
        headers: {
            'Content-Type': 'application/json',
            'apiKey': 'hbJjQs8owLIrS5wPVr34WN1BhMH7evBl5iFklQiTnOdcfHi9Q9S4O21kEtumto8v',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT,DELETE"
        },
        data: {
            firstName: 'Fred',
            lastName: 'Flintstone'
        }
    };


    axios.post("https://eu-central-1.aws.data.mongodb-api.com/app/application-0-rvxwc/endpoint/test", {
        firstName: 'Fred',
        lastName: 'Flintstone'
    },
        {
            headers: {
                'Content-Type': 'application/json',
                'apiKey': 'hbJjQs8owLIrS5wPVr34WN1BhMH7evBl5iFklQiTnOdcfHi9Q9S4O21kEtumto8v'
            },
        }

    )
        .then((response) => {

            console.log("🟡 --- response:", response)




        })
        .catch((error) => {
            console.log(error);

        });
}


export const getSessions = ({ state, dispatch, commit }) => {
    axios
        .get(sessionizeUrl + "Sessions")
        .then((response) => {



            commit("SET_SESSIONS", response.data[0].sessions);
        })
        .catch((error) => {
            console.log(error);

        });
}
export const getSpeakers = ({ state, dispatch, commit }) => {
    axios
        .get(sessionizeUrl + "Speakers")
        .then((response) => {


            commit("SET_SPEAKERS", response.data);
        })
        .catch((error) => {
            console.log(error);

        });
}
export const getAll = ({ state, dispatch, commit }) => {
    return new Promise((resolve, reject) => {
        axios
            .get(sessionizeUrl + "All")
            .then((response) => {

                commit("SET_ALL", response.data);



                var tracks = response.data.categories[1].items


                function fixTag(tagObj) {
                    let tag = "";
                    if (tagObj.org) {
                        tag = tagObj.org;
                    } else {
                        tag = tagObj;
                    }
                    tag = tag.replace(/\./g, "");
                    tag = tag.replace(/ & /g, "-");
                    tag = tag.replace(/ /g, "-");
                    tag = tag.replace(/#/g, " ");
                    return tag;
                }

                tracks = tracks.map(e => {

                    let fixed = fixTag(e.name)
                    let color = "#E34407"

                    if (fixed === "Web" || fixed === "JVM") {
                        color = "#DE9FC2"
                    } else
                        if (fixed === "Data" || fixed === "DATA" || fixed === "Security") {
                            color = "#F9AA41"
                        } else
                            if (fixed === "AI" || fixed === "OFF") {
                                color = "#3F875D"
                            } else
                                if (fixed === "NET" || fixed === "Cloud-DevOps" || fixed === "Quality-Test") {
                                    color = "#2f71d0"
                                } else {
                                    color = "#E34407"
                                }


                    const obj = {
                        org: e.name,
                        fixed: fixed,
                        color
                    }
                    return obj
                })


                commit("SET_TRACKS", tracks);

                resolve(response)

            })
            .catch((error) => {
                console.log(error);
                reject(error)

            });

    })


}

export const increment = (context) => {
    context.commit('increment')
}

export const filterOldSchedules = async (context) => {
    const myscheduleid = localStorage.getItem('myscheduleid')
    const revertmyschedule = localStorage.getItem('revertmyschedule')

    // Remove cached scheduleId if it does not exist in mongo
    if (myscheduleid) {
        try {
            const response = await atlasAPI.get("getSchedule?id=" + myscheduleid);
            if (!response || !response.data || !response.data._id) {
                localStorage.setItem('myscheduleid', "")
            } else {
                // Set cached schedule from mongo
                const schedule = response.data.sessions;
                localStorage.setItem("schedule", JSON.stringify(schedule));
                context.commit("setCount", schedule.length);
            }
        } catch (error) {
            console.log(error);
        }
    }

    // Remove cached revertmyschedule if it does not exist in mongo
    if (revertmyschedule) {
        try {
            const response = await atlasAPI.get("getSchedule?id=" + revertmyschedule);
            if (!response || !response.data || !response.data._id) localStorage.setItem('revertmyschedule', "");
        } catch (error) {
            console.log(error);
        }
    }

    if (!localStorage.getItem("schedule") || localStorage.getItem("schedule") === "undefined" || localStorage.getItem("schedule") === "null") {
        localStorage.setItem("schedule", JSON.stringify([]))
    } else {
    // Filter old cached sessions
        const schedule = JSON.parse(localStorage.getItem("schedule"));
        axios
            .get(sessionizeUrl + "Sessions")
            .then((response) => {
                const allSessionIds = response.data[0].sessions.map(val => String(val.id));

                // Filter out IDs in locStoredSchedules that are not in allSessionIds
                const filteredSchedule = schedule.filter(sessionId => allSessionIds.includes(String(sessionId)));

                // Set filtered as local storage
                localStorage.setItem("schedule", JSON.stringify(filteredSchedule));

                context.commit("setCount", filteredSchedule.length);
            }).catch((error) => {
                console.log(error);
            })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js